/**
 * TanStack Query hooks for `lead-ownership-transfer-tracking-sold-to-tracking`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	leadOwnershipTransferTrackingSoldToTrackingQueryKeys,
	type CreateLeadOwnershipTransferTrackingSoldToTrackingBody,
	type ListLeadOwnershipTransferTrackingSoldToTrackingResponse,
	type LeadOwnershipTransferTrackingSoldToTrackingRow,
} from "./api";

export function useLeadOwnershipTransferTrackingSoldToTrackingList(): UseQueryResult<ListLeadOwnershipTransferTrackingSoldToTrackingResponse, Error> {
	return useQuery({
		queryKey: leadOwnershipTransferTrackingSoldToTrackingQueryKeys.list(),
		queryFn: list,
	});
}

export function useLeadOwnershipTransferTrackingSoldToTrackingCreate(): UseMutationResult<LeadOwnershipTransferTrackingSoldToTrackingRow, Error, CreateLeadOwnershipTransferTrackingSoldToTrackingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: leadOwnershipTransferTrackingSoldToTrackingQueryKeys.all });
		},
	});
}

export function useLeadOwnershipTransferTrackingSoldToTrackingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: leadOwnershipTransferTrackingSoldToTrackingQueryKeys.all });
		},
	});
}
